import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import './style.css'
import Navbar from "../component/common/Navbar";
const faqs = [
  {
    question: "What is PlayGG?",
    answer:
      "PlayGG is the ultimate gaming hub. Book top-tier gaming cafes online, compete in thrilling tournaments for real prizes, gear up affordably from our marketplace, and connect with a vibrant gaming community. It's your gateway to a complete gaming universe.",
  },
  {
    question: "When is the PlayGG app launching?",
    answer: "The PlayGG app is launching soon! Stay tuned for updates on our official launch date.",
  },
  {
    question: "What features will the PlayGG app have?",
    answer:
      "The app will include:\n- Gaming tournaments\n- Gaming cafe bookings\n- Mini-games\n- A community feature\n- Marketplace",
  },
  {
    question: "How can I download the PlayGG app?",
    answer: "Once launched, the app will be available for download on both the Google Play Store and Apple App Store.",
  },
  {
    question: "Is the PlayGG platform currently accessible?",
    answer: "The full features of PlayGG will be available exclusively in the app once it is launched.",
  },
  {
    question: "Will the app be free to use?",
    answer: "The app will be free to download, but certain services, like tournament participation and cafe bookings, may have associated charges.",
  },
  {
    question: "Can I sign up before the app launches?",
    answer: "Currently, registrations will open once the app is live. Stay connected with us for announcements.",
  },
  {
    question: "In which cities will the app's services be available?",
    answer: "PlayGG will initially be available in select cities in India. Check back soon for the list of supported locations.",
  },
  {
    question: "How can I stay updated about the app launch?",
    answer: "Follow us on our social media channels or visit our website for the latest updates about the PlayGG app launch.",
  },
  {
    question: "Will there be customer support in the app?",
    answer: "Yes, the app will include a dedicated support section to address your queries and assist with any issues.",
  },
  {
    question: "Can I book gaming cafes or register for tournaments through the website?",
    answer: "No, all features and services will be available exclusively in the app once it launches.",
  },
  {
    question: "How do I report bugs or suggest features for the app?",
    answer: "After launch, you can use the app's support section to report issues or share your feedback.",
  },
  {
    question: "Is the PlayGG app safe and secure to use?",
    answer: "Yes, PlayGG prioritizes user security and privacy. All data and transactions will be protected using industry-standard measures.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>  
        <Navbar />
    <div style={{paddingTop:120}} className="py-16 px-6">
      <h2 className="text-5xl font-black text-center mb-12 relative">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-green-400 to-blue-500">
          FAQ
        </span>
        <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 text-sm font-mono text-gray-400 tracking-wider">
          NEED HELP?
        </div>
      </h2>
      <div className="max-w-4xl mx-auto space-y-6">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`border-2 p-5 rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-green-400/20 ${
              openIndex === index
                ? "border-green-400 bg-gradient-to-r from-gray-900/50 to-transparent"
                : "border-gray-800 hover:border-green-400/50"
            }`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="flex justify-between items-center cursor-pointer group">
              <h3 className="text-xl font-bold group-hover:text-green-400 transition-colors">
                {faq.question}
              </h3>
              {openIndex === index ? (
                <ChevronUp className="text-green-400 w-6 h-6" />
              ) : (
                <ChevronDown className="text-gray-400 w-6 h-6 group-hover:text-green-400 transition-colors" />
              )}
            </div>
            {openIndex === index && (
              <p className="text-gray-300 mt-4 leading-relaxed pl-1">
                {faq.answer}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
    </>

  );
}
